<template>
  <ul>
    <li v-for="n in pageTemplates.amount" :key="n+10000" ><img :style="{ 'transform' : 'rotate(' + random() + 'deg)' }" src="../assets/img/stack/page.svg" alt="Content Page Template" /></li>
    <li v-if="hasShop"><img :style="{ 'transform' : 'rotate(' + random() + 'deg)' }" src="../assets/img/stack/shop.svg" alt="Online Shop" /></li>
    <li v-if="hasBlog"><img :style="{ 'transform' : 'rotate(' + random() + 'deg)' }" src="../assets/img/stack/blog.svg" alt="Blog" /></li>
  </ul>
</template>
<script>
export default {
  name: 'Stack',
  props: {
    configuration: {
      type: Array,
      required: true
    }
  },
  computed: {
    pageTemplates: function () {
      return this.configuration.find(item => item.id === 'pages')
    },
    hasShop: function () {
      return this.configuration.find(item => item.id === 'onlineshop').status
    },
    hasBlog: function () {
      return this.configuration.find(item => item.id === 'blogfunktion').status
    }
  },
  methods: {
    random: function () {
      return Math.floor(Math.random() * (8 + 8) - 8)
    }
  }
}
</script>
<style lang="scss" scoped>
/*
ul {
  user-select: none;
  margin: 20px auto 0 auto;
  padding: 0;
  position: relative;
  width: 200px;
  height: 180px;
  li {
    margin: 0;
    padding: 0;
    list-style: none;
    position: absolute;
    display: block;
    top:0;
    left: 0;
    img {
      width: 180px;
      border-radius: 30px;
      height: auto;
      box-shadow: 0 10px 10px 3px rgba(0,0,0,0.04);
    }
  }
}
*/
ul {
  margin: -20px -30px -30px -30px;
  padding: 0 20px;
  display: flex;
  flex-wrap: wrap;
  align-content: start;
  // flex-grow: 1;
  li {
    padding: 15px;
    width: 33.3332%;
    list-style: none;
    img {
      width: auto;
      height: auto;
      border-radius: 10%;
    }
  }
}
@media (min-width: 540px) {
  ul {
    li {
      width: 25%;
    }
  }
}
@media (min-width: 767px) {
  ul {
    li {
      width: 33.3332%;
    }
  }
}
@media (min-width: 1180px) {
  ul {
    li {
      width: 25%;
    }
  }
}
</style>
